import React from 'react'
import brisbaneBroncos from './assets/brisbane-broncos.svg'
import canberraRaiders from './assets/canberra-raiders.svg'
import canterburyBankstownBulldogs from './assets/canterbury-bankstown-bulldogs.svg'
import cronullaSharks from './assets/cronulla-sharks.svg'
import goldCoastTitans from './assets/gold-coast-titans.svg'
import manlyWarringahSeaEagles from './assets/manly-warringah-sea-eagles.svg'
import melbourneStorm from './assets/melbourne-storm.svg'
import newcastleKnights from './assets/newcastle-knights.svg'
import warriors from './assets/warriors.svg'
import northQueenslandCowboys from './assets/north-queensland-cowboys.svg'
import parramattaEels from './assets/parramatta-eels.svg'
import penrithPanthers from './assets/penrith-panthers.svg'
import rabbitohs from './assets/rabbitohs.svg'
import illawarraDragons from './assets/illawarra-dragons.svg'
import sydneyRoosters from './assets/sydney-roosters.svg'
import dolphins from './assets/dolphins.svg'
import westTigers from './assets/west-tigers.svg'

export const NRLTeamIcon: React.FC<{
  participationId: number
}> | null = ({ participationId }) => {
  const iconName = kambiSportTeamToIconMap[participationId]

  if (!iconName) {
    return null
  }

  return <img height={32} width={32} src={iconName} />
}

// =============
// Local Helpers
// =============

const kambiSportTeamToIconMap: Partial<Record<number, string>> = {
  1004953564: brisbaneBroncos,
  1000545006: canberraRaiders,
  1030003903: canberraRaiders,
  1030202034: canterburyBankstownBulldogs,
  1000545005: canterburyBankstownBulldogs,
  1030003905: cronullaSharks,
  1000545008: goldCoastTitans,
  1028240900: goldCoastTitans,
  1000545009: manlyWarringahSeaEagles,
  1000280267: melbourneStorm,
  1000545014: newcastleKnights,
  1000545010: warriors,
  1004953565: newcastleKnights,
  1028240902: newcastleKnights,
  1030003906: northQueenslandCowboys,
  1000545015: northQueenslandCowboys,
  1000545016: parramattaEels,
  1028240901: parramattaEels,
  1000545017: penrithPanthers,
  1000545019: rabbitohs,
  1004953567: rabbitohs,
  1000545018: illawarraDragons,
  1004953566: illawarraDragons,
  1000545020: sydneyRoosters,
  1028320297: dolphins,
  1000545021: westTigers,
  1030003904: westTigers,
}
